<template>
    <div class="congrid-modal">
        <b-modal id="congrid-modal" centered size="lg"  @show="loadCongridProjects"
                 title="Congrid options">

            <b-list-group>
                <b-list-group-item class="d-flex justify-content-between align-items-center" v-for="(congridProject, key) in congridProjects"
                                   @click="selectedCongridProject = (selectedCongridProject === congridProject.id ? null : congridProject.id) "
                                   :key="'congrid_project_' + key"
                >
                    <b-icon-check-square v-if="selectedCongridProject === congridProject.id"></b-icon-check-square>
                    <b-icon-square v-else></b-icon-square>
                    {{ congridProject.name }}

                    <b-badge variant="danger" pill>{{congridProject.id}}</b-badge>
                </b-list-group-item>
            </b-list-group>


            <template #modal-footer="{ cancel, ok }">
                <b-button @click="cancel">Cancel</b-button>

                <b-button @click="saveCongridProjectId(); ok()" variant="primary">
                    Save
                </b-button>
            </template>
        </b-modal>


    </div>
</template>

<script>
    import axios from 'axios';
    import '@css/settings-create-project.css';

    export default {
        props: {},
        data() {
            return {
                congridProjects: [],
                selectedCongridProject: this.$store.state.project.congrid_project_id
            };
        },
        methods: {
            loadCongridProjects() {

                if(this.congridProjects.length > 0){
                    return;
                }

                let token = this.$store.state.token;

                axios({
                    url: this.$store.getters.apiBase + '/congrid/projects',
                    method: 'GET',
                    headers: {"Authorization": "Bearer " + token}
                })
                    .then(response => {
                        if(response.data.length > 0 && typeof response.data[0] !== 'undefined'){
                            this.congridProjects = response.data[0].results;
                        }

                    })
                    .catch(error => {
                        console.log(error);
                    });
            },

            saveCongridProjectId(){
                let token = this.$store.state.token;

                axios({
                    url: this.$store.getters.apiProjectBase + '/congrid',
                    method: 'POST',
                    data: {
                        congrid_project_id: this.selectedCongridProject
                    },
                    headers: {"Authorization": "Bearer " + token}
                })
                    .then(response => {
                        this.$store.state.project.congrid_project_id = this.selectedCongridProject;
                        this.$bvModal.hide('remove-user-modal');
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        }
    }
</script>
